import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Subject } from "rxjs";
import { VersionControlService } from "./version-control.service";

@Injectable({
  providedIn: "root",
})
export class CommerrorService {
  Error: string;
  ErrorType: string;
  logError = false;
  ecnext$ = new Subject<void>();

  saveCalendar$ = new Subject<any>();
  saveConcent$ = new Subject<any>();
  calendarForm = false;
  concentForm = false;
  alreadyHasExam = false;
  sessionExpiration: boolean = false;

  isCardio = false;
  save = false;

  constructor(private versionService: VersionControlService) {
    this.ErrorType = "";
  }

  handleCommError(error: HttpErrorResponse) {
    this.calendarForm = null;
    console.log(error);
    this.logError = false;
    if (error.url.indexOf("http://localhost:8088/alive") > -1)
      //local server doesn't exist
      return;
    if (error.error instanceof ErrorEvent) {
      this.ErrorType = "Network";
      this.Error =
        "Network Error: Please check your network connection and try again.";
    } else {
      if (error.status == 401 && error.error["error"] == "missing user or pw")
        return; //don't display error
       if(error.status === 409 && error.error["error"] ){
          // exam_conflict carries its own resolution UI (questionnaire-templates
          // conflict modal) — don't also surface the generic error popup for it.
          if (error.error["conflicts"]) return;
          this.ErrorType = "Conflict";
          this.Error = error.error["error"];
          return
        }
        if (error.error.details) {
          // Green Invoice Error Handling:
          if (error.error.details.includes("GreenInvoiceError")) {
            this.ErrorType = "Green Invoice";
            this.Error = error.error.details.replace("GreenInvoiceError: ", "");
          } else if (Array.isArray(error.error.details)) {
            this.ErrorType = "Missing Data";
            this.Error = error.error.details[0].message;
          } else {
            this.ErrorType = "Error";
            this.Error = error.error.details;
          }
          return;
        }
      if (error.status == 409)
        //on add new user id already exists
        return;

      if (error.status === 200) {
        return
      }
      

      if(error.status === 401 && error.error["error"] === "need to login"){
        this.ErrorType = "Session";
        this.Error = "Your session has expired. Please login.";
      } else {
         if (error.status === 426) {
           this.versionService.triggerVersionMismatch();
           return; 
         }
         if (this.ErrorType === 'VERSION_MISMATCH'){
           return
        }        
        if (error.status == 0) {
          this.ErrorType = "Can not reach server";
          this.Error = "Check network connectivity (last action not saved)";
        } else {
          this.ErrorType = "Server";
          this.Error = error.status + ": " + JSON.stringify(error);
          if (error["error"] && error.error["error"]) {
            if (typeof error.error["error"] == "string") {
              this.Error =
                error.status + ": " + JSON.stringify(error.error["error"]);
            } else {
              this.Error =
                error.status + ": " + JSON.stringify(error.error["error"]);
            }
          }
        }
      }
    }
  }

  error(data, loginerror = false) {
    this.calendarForm = null;
    this.alreadyHasExam = null;
    this.ErrorType = data;
    this.logError = loginerror;
  }

  errorCardio(data, loginerror = false) {
    this.calendarForm = null;
    this.alreadyHasExam = null;
    this.ErrorType = data;
    this.logError = loginerror;
    this.isCardio = true;
  }

  hasExam(data, loginerror = false) {
    this.isCardio = false;
    this.calendarForm = null;
    this.alreadyHasExam = true;
    this.ErrorType = data;
    this.logError = loginerror;
    this.Error = "Do you really want to create a new one?";
  }

  errorCalendar(data = null) {
    this.alreadyHasExam = null;
    this.Error = data;
    this.ErrorType = "Save This Pregnancy Planner?";
    this.calendarForm = true;
    this.concentForm = false;
    if(data){
      this.concentForm = true;
      this.ErrorType = data;
    }
  }

  errorSession(errorType: string, errorMessage: string){
    this.calendarForm = null;
    this.concentForm = false;
    this.sessionExpiration = true
    this.ErrorType = errorType;
    this.Error = errorMessage;
  }

  resetErr() {
    this.Error = null;
    this.ErrorType = "";
  }
}
